<img *ngIf="channelLogo" [src]="channelLogo | img: logoParams" alt="default page loader" />
<ush-dots-loader [dotsColor]="dotsColor"></ush-dots-loader>
